export default __webpack_public_path__ + "static/media/gothenburg_background_xl2.25d1db29.jpg";